import React from 'react';

import { useFormContext } from 'react-hook-form';
import { OverlayComponentProps } from '../InteractionInfo';
import { OverlayInteractionMode } from '../types';

import { useWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { logger } from '$/utils/logger';

import { useHasChangedShallow } from '$/hooks/useHasChanged';

const AnchorOverlay: React.FC<OverlayComponentProps> = ({
  overlayMode,
  interaction,
}): JSX.Element | null => {
  const { setIsPlaying, playbackPosition, isScrobbling, loaded, isSeeking } =
    useWebinarPlayerContext();
  const [firstTime, setFirstTime] = React.useState(true);

  const formContext = useFormContext();
  const pauseAt =
    (formContext?.watch('details.playbackPosition') as number | undefined) ??
    interaction.playbackPosition;

  const hasChanged = useHasChangedShallow([
    firstTime,
    interaction.details?.anchor?.pause,
    interaction.details?.anchor?.pauseMessage,
    interaction.details?.anchor?.pauseSecs,
    overlayMode,
    pauseAt,
    playbackPosition,
  ]);

  logger.debug('PLAY', '[][] ANCHOR OVERLAY LOGIC ');

  React.useEffect(() => {
    if (
      overlayMode === OverlayInteractionMode.InCard ||
      !interaction.details?.anchor?.pause ||
      isScrobbling ||
      isSeeking
    )
      return;

    // In edit we allow re-rendering. Otherwise we don't update the preview
    if (overlayMode === OverlayInteractionMode.Edit) {
      if (!loaded || Math.floor(playbackPosition) !== pauseAt || (!firstTime && !hasChanged))
        return;
    } else {
      if (!firstTime) return;
    }

    setFirstTime(false);

    logger.debug('PLAY', '[][] ANCHOR PAUSE w/ TIMER ISPLAYING ', {
      playback: playbackPosition,
      pauseAt,
      pause: interaction.details?.anchor?.pauseSecs,
    });
    setIsPlaying(false, {
      secsToPause: interaction.details?.anchor?.pauseSecs,
      message: interaction.details?.anchor?.pauseMessage,
    });
  }, [
    loaded,
    hasChanged,
    firstTime,
    interaction.details?.anchor?.pause,
    interaction.details?.anchor?.pauseMessage,
    interaction.details?.anchor?.pauseSecs,
    isScrobbling,
    overlayMode,
    pauseAt,
    playbackPosition,
    setIsPlaying,
    isSeeking,
  ]);

  // Nothing to render - Controls does it all
  return null;
};

export default AnchorOverlay;
